import React from 'react'

const ITDashboardMain = () => {
  return (
    <div>ITDashboardMain</div>
  )
}

export default ITDashboardMain